<template>
  <section class="ws-advanced-search">
    <ws-filter-item
      id="humanreadble"
      :type="filterType.SEARCH"
      :label="$t('Поиск по ID')"
      @ready="onHumanIdReady"
      @change="onHumanIdChange"
    >
    </ws-filter-item>
    <header
      class="ws-advanced-search__header"
      @click="isOpen = !isOpen"
    >
      <h3
        class="ws-advanced-search__title has-text-primary is-size-2"
        v-text="title"
      ></h3>
      <div class="ws-advanced-search__actions">
        <button
          class="ws-button button is-text"
          :aria-controls="id"
        >
          <ws-icon
            class="ws-button__icon"
            name="arrow-thin"
            color="#000000"
            :class="{'ws-icon--left': !isOpen}"
            :fill="false"
            :title="$t('Свернуть/Развернуть')"
            width="17"
            height="11"
          />
        </button>
      </div>
    </header>
    <b-collapse
      class="ws-advanced-search__form"
      :aria-id="id"
      :open.sync="isOpen"
    >
      <div class="columns">
        <div class="column">
          <ws-permission-node :resources="['resources/region']">
            <ws-filter-item
              id="region_guid"
              resourceId="region"
              field="title.display"
              :type="filterType.REFBOOK"
              :label="$t('Регион')"
              entity="public/refbook/region"
              :params="{country: config.default_country_code}"
              @ready="onFilterReady"
              @change="onFilter"
            >
            </ws-filter-item>
          </ws-permission-node>
        </div>
        <div class="column">
          <ws-permission-node :resources="['resources/competency']">
            <ws-filter-item
              id="competency_guid"
              resourceId="competency"
              field="name.display"
              :type="filterType.REFBOOK"
              :label="$t('Профессия/специальность (ДЭ)')"
              entity="competence"
              @ready="onFilterReady"
              @change="onFilter"
            >
            </ws-filter-item>
          </ws-permission-node>
        </div>
        <div class="column">
          <ws-filter-item
            id="de_center_guid"
            field="name.display"
            :type="filterType.REFBOOK"
            :label="$t('ЦПДЭ')"
            entity="de-centers"
            @ready="onFilterReady"
            @change="onFilter"
          >
            <template
              slot="item"
              slot-scope="props"
            >
              <div class="is-flex">
                <p>
                  <small v-if="props.option.visible === false" class="icon-overlay">
                    <ws-icon
                      name="stop"
                      color="red"
                      height="15"
                      width="13"
                      class="icon-stop"
                    />
                  </small>
                  <span>
                    {{ props.option.name.display }}
                  </span>
                </p>
              </div>
              <small class="has-text-grey">{{ props.option.address.region.title.display }},
                <span v-if="props.option.address.locality">{{ props.option.address.locality.title.display }}</span>,
                {{ props.option.address.address.display }}
              </small>
            </template>
          </ws-filter-item>
        </div>
        <div class="column">
          <ws-filter-item
            id="exam_status"
            :type="filterType.SELECT"
            :label="$t('Статус экзамена')"
            @ready="onFilterReady"
            :options="exam_statuses"
            :default-value="default_exam_status"
            @change="onFilter"
          >
          </ws-filter-item>
        </div>
        <div
          class="column"
          style="flex-grow: initial; align-self: center;"
        >
          <button
            class="ws-button button is-text"
            @click="isToggleExpandedFilters = !isToggleExpandedFilters"
          >
            <ws-icon
              class="ws-button__icon"
              name="filter"
              :fill="true"
              :color="`#777`"
              :title="$t('Расширенный список фильтров')"
              width="18"
              height="18"
            />
          </button>
        </div>
      </div>

      <div
        class="ws-advanced-search__filters-expanded"
        v-show="isToggleExpandedFilters"
      >
        <div class="columns is-multiline">
          <div class="column is-2">
            <ws-filter-item
              id="started_at.from"
              :label="$t('Дата начала (от)')"
              :type="filterType.DATE"
              @ready="onFilterReady"
              @change="onFilter"
            >
            </ws-filter-item>
          </div>
          <div class="column is-2">
            <ws-filter-item
              id="started_at.till"
              :label="$t('Дата начала (до)')"
              :type="filterType.DATE"
              @ready="onFilterReady"
              @change="onFilter"
            >
            </ws-filter-item>
          </div>
          <div class="column is-2">
            <ws-filter-item
              id="ended_at.from"
              :label="$t('Дата окончания (от)')"
              :type="filterType.DATE"
              @ready="onFilterReady"
              @change="onFilter"
            >
            </ws-filter-item>
          </div>
          <div class="column is-2">
            <ws-filter-item
              id="ended_at.till"
              :label="$t('Дата окончания (до)')"
              :type="filterType.DATE"
              @ready="onFilterReady"
              @change="onFilter"
            >
            </ws-filter-item>
          </div>
          <div class="column is-2">
            <ws-filter-item
              id="created_at.from"
              :label="$t('Дата создания (от)')"
              :type="filterType.DATE"
              @ready="onFilterReady"
              @change="onFilter"
            >
            </ws-filter-item>
          </div>
          <div class="column is-2">
            <ws-filter-item
              id="created_at.till"
              :label="$t('Дата создания (до)')"
              :position="'is-bottom-left'"
              :type="filterType.DATE"
              @ready="onFilterReady"
              @change="onFilter"
            >
            </ws-filter-item>
          </div>
          <div class="column is-2">
            <ws-filter-item
              id="updated_at.from"
              :label="$t('Дата редактирования (от)')"
              :type="filterType.DATE"
              @ready="onFilterReady"
              @change="onFilter"
            >
            </ws-filter-item>
          </div>
          <div class="column is-2">
            <ws-filter-item
              id="updated_at.till"
              :label="$t('Дата редактирования (до)')"
              :type="filterType.DATE"
              @ready="onFilterReady"
              @change="onFilter"
            >
            </ws-filter-item>
          </div>
          <div class="column is-2">
            <ws-filter-item
              id="day_cm1.from"
              ref="day_cm1.from"
              :label="$t('Дата ПД (от)')"
              :type="filterType.DATE"
              @ready="onFilterReady"
              @change="onFilter"
            >
            </ws-filter-item>
          </div>
          <div class="column is-2">
            <ws-filter-item
              id="day_cm1.till"
              ref="day_cm1.till"
              :label="$t('Дата ПД (до)')"
              :type="filterType.DATE"
              @ready="onFilterReady"
              @change="onFilter"
            >
            </ws-filter-item>
          </div>
        </div>

        <div class="columns">
          <div class="column is-4">
            <ws-filter-item
              id="is_center_accred"
              :type="filterType.SELECT"
              :label="$t('Статус аккредитации ЦПДЭ')"
              @ready="onFilterReady"
              :options="[
                { label: $t('Не важно'), value: '' },
                { label: $t('Обследован'), value: 'true' },
                { label: $t('Не обследован'), value: 'false' }
              ]"
              @change="onFilter"
            >
            </ws-filter-item>
          </div>
          <div class="column is-4">
            <ws-permission-node :resources="['resources/university']">
              <ws-filter-item
                id="university_guid"
                resourceId="university"
                field="title.display"
                :type="filterType.REFBOOK"
                :label="$t('Образовательная организация')"
                entity="public/refbook/education/institution"
                @ready="onFilterReady"
                @change="onFilter"
              >
                <template
                    slot="item"
                    slot-scope="props"
                >
                  <p>
                    <ws-icon v-if="props.option.visible === false" name="stop" color="red" class="icon-stop" width="15" height="15"/>
                    {{ props.option.title.display }}
                  </p>
                  <small class="has-text-grey">{{ props.option.address.region && props.option.address.region.title.display }},
                    {{ props.option.address.locality && props.option.address.locality.title.display }},
                    {{ props.option.address.address.display }}
                  </small>
                </template>
              </ws-filter-item>
            </ws-permission-node>
          </div>
          <div class="column is-4">
            <ws-filter-item
              id="qualification_guid"
              field="name.translate.ru"
              :type="filterType.REFBOOK"
              :label="$t('Квалификация')"
              entity="skill-matrix/qualification"
              @ready="onFilterReady"
              @change="onFilter"
            >
            </ws-filter-item>
          </div>
        </div>
        <div class="columns">
          <div class="column is-4">
            <ws-filter-item
              id="main_expert_guid"
              field="fullName"
              :type="filterType.REFBOOK"
              :custom-formatter="formatUserFullName"
              :placeholder="$t('Введите ФИО эксперта')"
              :label="$t('ФИО ГЭ')"
              entity="refbook/experts"
              @ready="onFilterReady"
              @change="onFilter"
            >
              <template
                slot-scope="props"
                slot="item"
              >
                <div class="media">
                  <div class="media-left">
                    <figure class="image is-48x48">
                      <ws-avatar
                        v-if="props.option.user_info"
                        :id="props.option.user_info.guid"
                        :name="`${ props.option.user_info.first.display } ${props.option.user_info.last.display}`"
                        sizeType="Small"
                        :size="48"
                      />
                    </figure>
                  </div>
                  <div class="media-content">
                    <span v-if="props.option.user_info">
                      <span v-if="props.option.user_info.last.display && props.option.user_info.first.display">
                        <strong>{{ props.option.user_info.last.display }} {{ props.option.user_info.first.display }} {{ props.option.user_info.middle.display }}</strong> <br>
                        <span class="is-size-5">{{ props.option.region.title.display }}</span><br>
                        <span class="has-text-primary">{{ props.option.user_info.email }}</span>
                      </span>
                    </span>
                    <span v-else>
                      <strong>{{ props.option.email }}</strong>
                    </span>
                  </div>
                </div>
              </template>
              <template slot="empty">{{$t('Пользователь не найден')}}</template>
            </ws-filter-item>
          </div>
          <div class="column is-4">
            <ws-filter-item
              id="main_expert_status"
              :type="filterType.SELECT"
              :label="$t('Статус ГЭ')"
              @ready="onFilterReady"
              :options="[
                { label: $t('Не важно'), value: '' },
                { label: $t('Не запрошен'), value: 'none' },
                { label: $t('Запрошен, но не утвержден'), value: 'requested' },
                { label: $t('Подтверждён'), value: 'accepted' },
              ]"
              @change="onFilter"
            >
            </ws-filter-item>
          </div>
          <div class="column is-4">
            <ws-filter-item
              id="lineal_expert_status"
              :type="filterType.SELECT"
              :label="$t('Статус эксперта')"
              @ready="onFilterReady"
              :options="[
                { label: $t('Не важно'), value: '' },
                { label: $t('Не запрошен'), value: 'none' },
                { label: $t('Запрошен, но не утвержден'), value: 'requested' },
                { label: $t('Подтверждён'), value: 'accepted' },
              ]"
              @change="onFilter"
            >
            </ws-filter-item>
          </div>
        </div>

        <div class="columns">
          <div class="column is-4">
            <ws-filter-item
              id="tech_expert_guid"
              field="fullName"
              :type="filterType.REFBOOK"
              :custom-formatter="formatTEUserFullName"
              :placeholder="$t('Введите ФИО эксперта')"
              :label="$t('ФИО ТЭ')"
              :query="{mode: 'ext/profile/contacts'}"
              entity="esatk/users"
              @ready="onFilterReady"
              @change="onFilter"
            >
              <template
                slot-scope="props"
                slot="item"
              >
                <div class="media">
                  <div class="media-left">
                    <figure class="image is-48x48">
                      <ws-avatar
                        :id="props.option.guid"
                        :name="`${ props.option.first.display } ${props.option.last.display}`"
                        sizeType="Small"
                        :size="48"
                      />
                    </figure>
                  </div>
                  <div class="media-content">
                    <span v-if="props.option.last.display && props.option.first.display">
                      <strong>{{ props.option.last.display }} {{ props.option.first.display }} {{ props.option.middle.display }}</strong> <br>
                      <span class="has-text-primary">{{ props.option.email }}</span><br>
                    </span>
                  </div>
                </div>
              </template>
              <template slot="empty">{{$t('Пользователь не найден')}}</template>
            </ws-filter-item>
          </div>
          <div class="column is-4">
            <ws-filter-item
              id="tech_expert_status"
              :type="filterType.SELECT"
              :label="$t('Статус ТЭ')"
              @ready="onFilterReady"
              :options="[
                { label: $t('Не важно'), value: '' },
                { label: $t('Не запрошен'), value: 'none' },
                { label: $t('Запрошен, но не утвержден'), value: 'requested' },
                { label: $t('Подтверждён'), value: 'accepted' },
              ]"
              @change="onFilter"
            >
            </ws-filter-item>
          </div>
          <div class="column is-4">
            <ws-filter-item
                id="lineal_expert_guid"
                field="fullName"
                :type="filterType.REFBOOK"
                :custom-formatter="formatTEUserFullName"
                :placeholder="$t('Введите ФИО эксперта')"
                :label="$t('ФИО эксперта')"
                :query="{mode: 'ext/profile/contacts'}"
                entity="esatk/users"
                @ready="onFilterReady"
                @change="onFilter"
            >
              <template
                  slot-scope="props"
                  slot="item"
              >
                <div class="media">
                  <div class="media-left">
                    <figure class="image is-48x48">
                      <ws-avatar
                          :id="props.option.guid"
                          :name="`${ props.option.first.display } ${props.option.last.display}`"
                          sizeType="Small"
                          :size="48"
                      />
                    </figure>
                  </div>
                  <div class="media-content">
                    <span v-if="props.option.last.display && props.option.first.display">
                      <strong>{{ props.option.last.display }} {{ props.option.first.display }} {{ props.option.middle.display }}</strong> <br>
                      <span class="has-text-primary">{{ props.option.email }}</span><br>
                    </span>
                  </div>
                </div>
              </template>
              <template slot="empty">{{$t('Пользователь не найден')}}</template>
            </ws-filter-item>
          </div>
        </div>

        <div class="columns is-multiline">
          <div class="column is-4">
            <ws-filter-item
              id="format-demo-exam"
              :type="filterType.SELECT"
              :label="$t('Формат проведения ДЭ')"
              @ready="onFilterReady"
              @change="onFilter"
              :options="[
                  { label: $t('Все'), value: undefined },
                  { label: $t('дистанционные участники'), value: 'remote_members' },
                  { label: $t('дистанционные эксперты'), value: 'remote_experts' },
                  { label: $t('дистанционные участники и эксперты'), value: 'remote_experts,remote_members' }
                ]"
            >
            </ws-filter-item>
          </div>
          <div class="column is-4">
            <ws-filter-item
                id="type-of-certification"
                :type="filterType.SELECT"
                :label="$t('Вид аттестации ГИА/ПА')"
                @ready="onFilterReady"
                @change="onFilter"
                :options="[
                  { label: $t('Все'), value: undefined },
                  { label: $t('Промежуточная аттестация (Cтудент)'), value: 'intermediate' },
                  { label: $t('Промежуточная аттестация (Выпускник)'), value: 'total' },
                  { label: $t('ГИА'), value: 'state_final_attestation' },
                ]"
            >
            </ws-filter-item>
          </div>
          <div class="column is-4">
            <ws-filter-item
                id="expert_certificates"
                :type="filterType.SELECT"
                :label="$t('Сертификат эксперта')"
                @ready="onFilterReady"
                @change="onFilter"
                :options="[
                  { label: $t('Все'), value: undefined },
                  { label: $t('Главный эксперт'), value: 'main' },
                  { label: $t('Технический эксперт'), value: 'technical' },
                  { label: $t('Эксперт'), value: 'lineal' },
                  { label: $t('Отсутствует у главного эксперта'), value: 'main_off' },
                  { label: $t('Отсутствует у технического эксперта'), value: 'technical_off' },
                  { label: $t('Отсутствует у эксперта'), value: 'lineal_off' },
                ]"
            >
            </ws-filter-item>
          </div>
          <div class="column is-4">
            <ws-filter-item
                id="level-demo-exam"
                :type="filterType.SELECT"
                :label="$t('Уровень ДЭ')"
                @ready="onFilterReady"
                @change="onFilter"
                :options="[
                  { label: $t('Все'), value: undefined },
                  { label: $t('Студент (ПА)'), value: 'intermediate' },
                  { label: $t('Выпускник (ПА)'), value: 'total' },
                  { label: $t('Базовый уровень (ГИА)'), value: 'de_level_basic' },
                  { label: $t('Профильный уровень (ГИА)'), value: 'de_level_prof_skill' },
                  { label: $t('Профильный уровень (вариативная часть)'), value: 'de_level_variant' },
                ]"
            >
            </ws-filter-item>
          </div>
          <div class="column is-4">
            <ws-filter-item
                id="accred_level"
                :type="filterType.REFBOOK"
                :label="$t('Уровень КОД')"
                field="name"
                entity="skill-matrix/complexity-levels"
                @ready="onFilterReady"
                @change="onFilter"
            >
            </ws-filter-item>
          </div>
          <div class="column is-2">
            <ws-filter-item
                id="is_spo"
                :type="filterType.SELECT"
                :label="$t('flags.secondary_degree')"
                @ready="onFilterReady"
                @change="onFilter"
                :options="[
                  { label: $t('Не важно'), value: '' },
                  { label: $t('Да'), value: 'true' },
                  { label: $t('Нет'), value: 'false' }
                ]"
            >
            </ws-filter-item>
          </div>
          <div class="column is-2">
            <ws-filter-item
              id="is_vo"
              :type="filterType.SELECT"
              :label="$t('Программа ВО')"
              @ready="onFilterReady"
              @change="onFilter"
              :options="[
                  { label: $t('Не важно'), value: '' },
                  { label: $t('Да'), value: 'true' },
                  { label: $t('Нет'), value: 'false' }
                ]"
            >
            </ws-filter-item>
          </div>
          <div class="column is-2">
            <ws-filter-item
              id="has_kod"
              :type="filterType.SELECT"
              :label="$t('Наличие КОД')"
              @ready="onFilterReady"
              @change="onFilter"
              :options="[
                  { label: $t('Не важно'), value: '' },
                  { label: $t('Да'), value: 'true' },
                  { label: $t('Нет'), value: 'false' }
                ]"
            >
            </ws-filter-item>
          </div>
          <div class="column is-2">
            <ws-filter-item
              id="is_noc"
              :type="filterType.SELECT"
              :label="$t('Статус НОК')"
              @ready="onFilterReady"
              @change="onFilter"
              :options="[
                  { label: $t('Не важно'), value: '' },
                  { label: $t('Да'), value: 'true' },
                  { label: $t('Нет'), value: 'false' }
                ]"
            >
            </ws-filter-item>
          </div>
          <div class="column is-2">
            <ws-filter-item
              id="has_report_file"
              :type="filterType.SELECT"
              :label="$t('Файл отчета')"
              @ready="onFilterReady"
              @change="onFilter"
              :options="[
                  { label: $t('Не важно'), value: '' },
                  { label: $t('Да'), value: 'true' },
                  { label: $t('Нет'), value: 'false' }
                ]"
            >
            </ws-filter-item>
          </div>
          <div class="column is-2">
            <ws-filter-item
              id="has_ready_act"
              :type="filterType.SELECT"
              :label="$t('Файл акта готовности')"
              @ready="onFilterReady"
              @change="onFilter"
              :options="[
                  { label: $t('Не важно'), value: '' },
                  { label: $t('Да'), value: 'true' },
                  { label: $t('Нет'), value: 'false' }
                ]"
            >
            </ws-filter-item>
          </div>
          <div class="column is-2">
            <ws-filter-item
              id="has_noc_protocol"
              :type="filterType.SELECT"
              :label="$t('Файл протокола НОК')"
              @ready="onFilterReady"
              @change="onFilter"
              :options="[
                  { label: $t('Не важно'), value: '' },
                  { label: $t('Да'), value: 'true' },
                  { label: $t('Нет'), value: 'false' }
                ]"
            >
            </ws-filter-item>
          </div>
        </div>
      </div>
    </b-collapse>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { constants } from '@/services/constants.service'
import WsFilterItem from '@/components/common/WsFilterItem'
import filterType from '@/components/common/data/filter-type.enum'
import examsFilterMixin from '@/mixins/exam-filter.mixin'

const DEFAULT_EXAM_STATUSES = Object.values(constants.exam_status).join(',')

// TODO: PROF-14 skill-matrix
export default {
  name: 'WsDemoExamsFilter',
  components: { WsFilterItem },
  mixins: [examsFilterMixin],
  data () {
    return {
      constants,
      config: __config,
      exam_statuses: [],
      default_exam_status: DEFAULT_EXAM_STATUSES,
      filterType
    }
  },
  computed: {
    ...mapGetters('profile', ['getUserSourcesPermission']),
    ...mapGetters('authentication', ['getUserGuid']),
    ...mapState('authentication', ['user', 'resourcesPermissions', 'currentRole'])
  },
  methods: {
    formatUserFullName (user) {
      if (user && user.user_info) {
        const fullName = `${user.user_info.last.display} ${user.user_info.first.display} ${user.user_info.middle.display}`
        user.fullName = fullName
        return fullName
      }
      return ''
    },
    formatTEUserFullName (user) {
      let fullName = null
      if (user) {
        fullName = `${user.last.display} ${user.first.display} ${user.middle.display}`
      }
      user.fullName = fullName
      return fullName
    }
  },
  async created () {
    switch (this.currentRole) {
      case 'front_mc':
        this.exam_statuses = [
          {
            value: this.default_exam_status,
            label: this.$t('exam.filter.status.all')
          }, ...Object.values(constants.exam_status).map(i => {
            return {
              value: i,
              label: this.$t(`exam.filter.status.${i}`)
            }
          })
        ]
        break
      case 'front_me':
        this.default_exam_status = DEFAULT_EXAM_STATUSES
        this.exam_statuses = [
          {
            value: this.default_exam_status,
            label: this.$t('exam.filter.status.all')
          }, ...Object.values(constants.exam_status).map(i => {
            return {
              value: i,
              label: this.$t(`exam.filter.status.${i}`)
            }
          })
        ]
        this.newFilter.main_expert_guids = this.user.guid
        this.newFilter.main_expert_accepted = true
        break
      default:
        this.default_exam_status = DEFAULT_EXAM_STATUSES
        this.exam_statuses = [
          {
            value: this.default_exam_status,
            label: this.$t('exam.filter.status.all')
          },
          {
            value: `${constants.exam_status.AGREED_DE_DEPARTMENT}`,
            label: this.currentRole === 'front_50plus' || this.currentRole === 'front_mio' ? this.$t('exam.filter.50plus.status.agreed_de_department') : this.$t('exam.filter.status.agreed_de_department')
          },
          {
            value: `${constants.exam_status.CONFIRMED_AUTH_ORG}`,
            label: this.currentRole === 'front_50plus' || this.currentRole === 'front_mio' ? this.$t('exam.filter.50plus.status.confirmed_auth_org') : this.$t('exam.filter.status.confirmed_auth_org')
          },
          {
            value: `${constants.exam_status.CONFIRMED_AUTH_ORG_BLOCKED}`,
            label: this.currentRole === 'front_50plus' || this.currentRole === 'front_mio' ? this.$t('exam.filter.50plus.status.confirmed_auth_org_blocked') : this.$t('exam.filter.status.confirmed_auth_org_blocked')
          },
          {
            value: `${constants.exam_status.APPROVED_MAIN_EXPERT}`,
            label: this.currentRole === 'front_50plus' || this.currentRole === 'front_mio' ? this.$t('exam.filter.50plus.status.approved_main_expert') : this.$t('exam.filter.status.approved_main_expert')
          },
          {
            value: `${constants.exam_status.APPROVED_MAIN_EXPERT_BLOCKED}`,
            label: this.currentRole === 'front_50plus' || this.currentRole === 'front_mio' ? this.$t('exam.filter.50plus.status.approved_main_expert_blocked') : this.$t('exam.filter.status.approved_main_expert_blocked')
          },
          {
            value: `${constants.exam_status.COMPLETE_MAIN_EXPERT}`,
            label: this.$t('exam.filter.status.complete_main_expert')
          },
          {
            value: `${constants.exam_status.COMPLETE_MAIN_EXPERT_BLOCKED}`,
            label: this.$t('exam.filter.status.complete_main_expert_blocked')
          }
        ]
    }
  }
}

</script>
<style lang="scss">
.icon-stop {
  display: inline-flex;
  align-self: center;
}

.icon-overlay {
  font-size: 1.2em;
}
</style>
